module.exports = __webpack_public_path__ + "static/media/PCWorkshopeDataCYBERSEGURANÇAEATAQUESHACKERS.59bcf793.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/cyberseguranca/PCWorkshopeDataCYBERSEGURANÇAEATAQUESHACKERS.png
// module id = 252
// module chunks = 0